module.exports = __webpack_public_path__ + "img/byjc.9081c1b3.png";